import {
    useContext,
    useMemo,
    type FC
} from "react";
import type ITooltipProviderProps from "./type";
import {
    TooltipDelayContext
} from "../../context";

const TooltipProvider: FC<ITooltipProviderProps> = ({
    closeDelay,
    openDelay,
    skipDelay,
    children
}) => {
    const parentDelays = useContext(TooltipDelayContext);

    const delays = useMemo(() => ({
        closeDelay: closeDelay ?? parentDelays?.closeDelay,
        skipDelay: skipDelay ?? parentDelays?.skipDelay,
        openDelay: openDelay ?? parentDelays?.openDelay
    }), [
        parentDelays,
        closeDelay,
        skipDelay,
        openDelay
    ]);

    return <TooltipDelayContext.Provider
        value={delays}
    >
        {children}
    </TooltipDelayContext.Provider>;
};
export default TooltipProvider;
